import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { sendOtp } from '../../../services'
import { validatePhoneNumber } from '../../../utils'
import { useAuth } from '../../../providers'

const initialRegistrationState = {
    status: 'idle',
    error: '',
}

const useRegister = () => {
    const [registerUserState, setRegisterUser] = useState(initialRegistrationState)

    // const location = useLocation();
    const navigate = useNavigate()

    const { status, error } = registerUserState
    const { phoneNumber } = useAuth()

    const handleRegister = async () => {
        setRegisterUser((prevValues) => ({ ...prevValues, error: null }))
        const result = validatePhoneNumber(phoneNumber)

        if (result !== 'valid') {
            return setRegisterUser((prevValues) => ({
                ...prevValues,
                error: result,
            }))
        }

        try {
            if (result === 'valid') {
                const formattedPhoneNumber = `+91${phoneNumber}`
                setRegisterUser((prevValues) => ({
                    ...prevValues,
                    status: 'loading',
                }))

                // const res = await registerUser(formattedPhoneNumber);
                // return console.log(location);
                const otpRes = await sendOtp(formattedPhoneNumber, false)

                // if (res?.data?.success) {
                // const otpRes = await sendOtp(formattedPhoneNumber);
                if (otpRes.data?.success) {
                    return setRegisterUser((prevValues) => ({
                        ...prevValues,
                        status: 'success',
                    }))
                }
                // }

                setRegisterUser((prevValues) => ({
                    ...prevValues,
                    status: 'failed',
                    error: otpRes?.data?.error,
                }))
            }
        } catch (error) {
            setRegisterUser((prevValues) => ({
                ...prevValues,
                status: 'failed',
                error: error.message,
            }))
        }
    }

    useEffect(() => {
        if (status === 'success') {
            setRegisterUser((prevValues) => ({
                ...prevValues,
                status: 'idle',
            }))

            navigate('/otpverification', {
                state: {
                    from: '/register',
                },
            })
        }
    }, [status, navigate])

    return { handleRegister, error, status }
}

export default useRegister
